import type { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';
import { Spread } from '../utility/Spread';

export const Card: React.FC<
  PropsWithChildren<{
    title?: ReactNode;
    rightElem?: ReactNode;
    className?: string;
    withShadow?: boolean;
    withBorder?: boolean;
    gap?: number;
  }>
> = ({ title, rightElem, children, className, withShadow, withBorder, gap }) => (
  <CardContainer className={className} $withShadow={withShadow} $withBorder={withBorder} $gap={gap}>
    {(title || rightElem) && (
      <TitleContainer>
        <Spread>
          {typeof title === 'string' ? <h2>{title}</h2> : (title ?? <span>&nbsp;</span>)}
          {typeof rightElem === 'string' ? <span>{rightElem}</span> : (rightElem ?? <span>&nbsp;</span>)}
        </Spread>
      </TitleContainer>
    )}
    {typeof children === 'string' ? <span>{children}</span> : children}
  </CardContainer>
);

const CardContainer = styled.div<{ $withShadow?: boolean; $withBorder?: boolean; $gap?: number }>`
  background-color: ${({ theme }) => theme.colors.prototype.card};
  box-shadow: ${({ theme, $withShadow }) => ($withShadow ? theme.shadow.card : 'unset')};
  border: ${({ theme, $withBorder }) => ($withBorder ? `1px solid ${theme.colors.prototype.border};` : 'unset')};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => ($gap !== undefined ? `${$gap}px` : '16px')};
`;

export const TitleContainer = styled.div`
  color: ${({ theme }) => theme.colors.prototype.foreground};
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.42px;
  text-transform: uppercase;
`;
